// Keyboard Shortcuts OS Detection for Cross-Platform Compatibility

// Turbolinks Classic compatibility
var keyboardShortcutsReady;
keyboardShortcutsReady = function () {
  
  function updateKeyboardShortcut() {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0 || 
                 navigator.platform.toUpperCase().indexOf('IPHONE') >= 0 ||
                 navigator.platform.toUpperCase().indexOf('IPAD') >= 0;
    
    const searchTrigger = document.getElementById('searchCommandTrigger');
    
    // Skip if search trigger doesn't exist
    if (!searchTrigger) {
      setTimeout(updateKeyboardShortcut, 1000);
      return;
    }
    
    const shortcutText = isMac ? '⌘ + K' : 'Ctrl + K';
    
    // Build the complete tooltip title with the correct shortcut
    const tooltipTitle = `Open Search... <span style='border: 1px solid rgb(98, 98, 98); border-radius: 3px; padding: 2px 6px; margin-left: 5px; font-family: monospace; font-size: 10px;'><span id='keyboard-shortcut'>${shortcutText}</span></span>`;
    searchTrigger.setAttribute('title', tooltipTitle);
    
    // Refresh Bootstrap 3 Tooltips
    if (window.$) {
      try {
        // Destroy existing tooltip if it exists
        $(searchTrigger).tooltip('destroy');
        
        // Reinitialize tooltip with Bootstrap 3 pattern
        $(searchTrigger).tooltip({
          container: 'body'
        });
      } catch (error) {
        // Fallback: title attribute is already set above
      }
    }
  }
  
  // Run the update with a small delay to ensure DOM is ready
  setTimeout(updateKeyboardShortcut, 100);
};

$(document).ready(keyboardShortcutsReady);
/**
 * if using turbolinks
 */
$(document).on('page:load', keyboardShortcutsReady); 